const initialState = {
    isModalVisible: false,
  };
  
  const planModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_PLAN_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_PLAN_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default planModalReducer;
  